export class UserRole {
  constructor(
    public id: number,
    public name: string
  ) { }
}
